import { render, staticRenderFns } from "./OtherUserAvatar.vue?vue&type=template&id=9560ecbc&scoped=true&"
import script from "./OtherUserAvatar.vue?vue&type=script&lang=js&"
export * from "./OtherUserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserAvatar.vue?vue&type=style&index=0&id=9560ecbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9560ecbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VAvatar,VBadge})
